import { computed, inject } from 'vue';
import { License_RegistrationType, useLicenseDetailedViewQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';

// eslint-disable-next-line no-shadow
export enum InitiatorsMenuOptions {
  'FloatingCI' = 'Floating CI',
  'FixedCI' = 'Fixed CI',
  'FloatingInitiator' = 'Floating',
  'FixedInitiator' = 'Fixed',
  'None' = 'None',
}

export const setInitiatorType = (defaultLicenseInitiatorValue: License_RegistrationType, defaultLicenseCIInitiatorValue: License_RegistrationType) => {
  // initiator value is defined → set value according to the initiator field (assuming CI is 0) or if bot are defined  - Initiators logic wins
  if (
    (defaultLicenseCIInitiatorValue === License_RegistrationType.None && defaultLicenseInitiatorValue !== License_RegistrationType.None) ||
    (defaultLicenseCIInitiatorValue !== License_RegistrationType.None && defaultLicenseInitiatorValue !== License_RegistrationType.None)
  ) {
    if (defaultLicenseInitiatorValue === License_RegistrationType.Floating) {
      return InitiatorsMenuOptions.FloatingInitiator;
    }
    if (defaultLicenseInitiatorValue === License_RegistrationType.Fixed) {
      return InitiatorsMenuOptions.FixedInitiator;
    }
  }
  // CI initiator value is defined → set value according to the initiator field (assuming initiator is 0)
  if (defaultLicenseInitiatorValue === License_RegistrationType.None && defaultLicenseCIInitiatorValue !== License_RegistrationType.None) {
    if (defaultLicenseCIInitiatorValue === License_RegistrationType.Floating) {
      return InitiatorsMenuOptions.FloatingCI;
    }
    if (defaultLicenseCIInitiatorValue === License_RegistrationType.Fixed) {
      return InitiatorsMenuOptions.FixedCI;
    }
  }
  return InitiatorsMenuOptions.None;
};

export const useDefaultAgentLicense = () => {
  const coordinatorsService = inject(IKCoordinatorsService);
  const GQL_userLicenseDetailedQuery = useLicenseDetailedViewQuery(() => ({
    coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
  }));

  const license = computed(() => GQL_userLicenseDetailedQuery?.result?.value?.ibManagerEntities?.license);
  const hasFloatingHelpers = computed(() => (license?.value?.windows?.summary?.totalFloatingCores || 0) > 0);
  const hasFixedHelpers = computed(() => (license?.value?.windows?.summary?.totalFixedCores || 0) > 0);
  const hasFixedCIInitiators = computed(() => (license?.value?.windows?.summary?.totalFixedCIInitiators || 0) > 0);
  const hasFloatingCIInitiators = computed(() => (license?.value?.windows?.summary?.totalFloatingCIInitiators || 0) > 0);
  const hasFixedInitiators = computed(() => (license?.value?.windows?.summary?.totalFixedInitiators || 0) > 0);
  const hasFloatingInitiators = computed(() => (license?.value?.windows?.summary?.totalFloatingInitiators || 0) > 0);

  const initiatorsTypesList = computed(() => {
    const optionsList = ['None'];
    if (hasFloatingCIInitiators.value) {
      optionsList.push(InitiatorsMenuOptions.FloatingCI);
    }
    if (hasFixedCIInitiators.value) {
      optionsList.push(InitiatorsMenuOptions.FixedCI);
    }
    if (hasFloatingInitiators.value) {
      optionsList.push(InitiatorsMenuOptions.FloatingInitiator);
    }
    if (hasFixedInitiators.value) {
      optionsList.push(InitiatorsMenuOptions.FixedInitiator);
    }
    return optionsList;
  });

  const helpersTypesList = computed(() => {
    const optionsList = [License_RegistrationType.None];
    if (hasFloatingHelpers.value) {
      optionsList.push(License_RegistrationType.Floating);
    }
    if (hasFixedHelpers.value) {
      optionsList.push(License_RegistrationType.Fixed);
    }

    return optionsList;
  });

  return { helpersTypesList, initiatorsTypesList };
};
